/**
 * ActiveIcon Component
 *
 * Filled circle icon for active status from Grain Core design system (Figma).
 */

import type { SVGProps } from 'react';

interface ActiveIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function ActiveIcon({ className, ...props }: ActiveIconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M14 7C14 10.8659 10.8659 14 7 14C3.13409 14 0 10.8659 0 7C0 3.13409 3.13409 0 7 0C10.8659 0 14 3.13409 14 7ZM5.285 10.8882L11.2681 4.90445L10.3683 4.00464L5.35182 9.02109L3.77618 7.10564L2.81464 7.93927L5.285 10.8875V10.8882Z"
        fill="currentColor"
      />
    </svg>
  );
}
